/**
 * @module
 *
 * @import {Global} from '@acng/frontend-relativity';
 * @import {Vote} from '../service/votes.js';
 */

import {GlobalContext} from '@acng/frontend-relativity';

/**
 * @type {Global<Amateur['id'][]>}
 */
export const ctxVotables = GlobalContext([]);

/**
 * @type {Global<Vote[]>}
 */
export const ctxVotes = GlobalContext([]);

/**
 * @type {Global<Amateur['id'][]>}
 */
export const ctxMatches = GlobalContext([]);
